module.exports = require('./helpers/bundle-url').getBundleURL('1OwBs') + "demo-wonky.2ef732f7.svg" + "?" + Date.now();